















































import { Vue, Prop, Component } from 'vue-property-decorator';
import ProductMultiSelect from '@/components/Product/ProductMultiSelect.vue';
import GenericSearch from '@/components/Blocks/BookMeetingFlow/GenericSearch.vue';

type NewsListItem = {
    systemId: string;
    text: {
        value: string;
    };
    externalLink: string;
    linkText: string;
    htmlImages: string[];
    htmlImage: string;
    sticky: boolean;
    isTopNews: boolean;
    title: string;
    newsDate: string;
    introduction: string;
    url: string;
    category: string[];
    productArea: string[];
};

type KeyValuePair = {
    key: string;
    value: string;
};

@Component({
    components: {
        ProductMultiSelect,
        GenericSearch
    }
})
export default class SimpleNewsList extends Vue {
    @Prop({ default: () => '' }) dataItems!: string;
    @Prop({ default: () => [] }) dataFilterCategory!: string;
    @Prop({ default: () => [] }) dataFilterProductArea!: string;
    @Prop({ default: () => false }) usePin!: boolean;
    searchQuery: string = '';
    selectedCategories: string[] = [];
    selectedProductAreas: string[] = [];
    highlightedNewsIds: string[] = [];

    mounted() {
        const cookieName = 'highlightedNews';
        const existingCookie = document.cookie.split('; ').find(row => row.startsWith(cookieName + '='));
        this.highlightedNewsIds = existingCookie ? existingCookie.split('=')[1].split(',') : [];
    }
    get allNews() {
        if (!this.dataItems) {
            return [];
        }
        const newsJson = JSON.parse(this.dataItems) || [];
        console.log(newsJson);
        return newsJson || [];
    }

    public updateSearchQuery(query: string) {
        this.searchQuery = query;
    }

    public clearSearchQuery() {
        this.searchQuery = '';
    }

    productAreaTranslation(string: string) {
        const data: KeyValuePair[] = JSON.parse(this.dataFilterProductArea) || [];
        const productArea = data.find((item: KeyValuePair) => item.key === string);
        return productArea ? productArea.value : string;
    }

    categoryTranslation(string: string) {
        const data: KeyValuePair[] = JSON.parse(this.dataFilterCategory) || [];
        const category = data.find((item: KeyValuePair) => item.key === string);
        return category ? category.value : string;
    }

    linkUrl(url: string, externalLink: string) {
        if (externalLink) {
            return externalLink;
        }
        return url;
    }

    linkTarget(url: string, externalLink: string) {
        if (externalLink) {
            return '_blank';
        }

        if (url.indexOf('/storage/') > -1) {
            return '_blank';
        }

        return '_self';
    }

    toggleHighlight(systemId: string) {
        const cookieName = 'highlightedNews';
        const existingCookie = document.cookie.split('; ').find(row => row.startsWith(cookieName + '='));
        let highlightedNews = existingCookie ? existingCookie.split('=')[1].split(',') : [];
        if (highlightedNews.includes(systemId)) {
            highlightedNews = highlightedNews.filter(id => id !== systemId);
        } else {
            highlightedNews.push(systemId);
        }
        const expires = new Date();
        expires.setFullYear(expires.getFullYear() + 1);
        document.cookie = `${cookieName}=${highlightedNews.join(',')}; path=/; expires=${expires.toUTCString()}`;
        this.highlightedNewsIds = highlightedNews;
    }

    get filteredNews() {
        if (!this.searchQuery && !this.selectedCategories.length && !this.selectedProductAreas.length) {
            return this.allNews || [];
        }
        let filteredNews = this.allNews;
        //This always returns [] - not good
        if (this.selectedCategories.length) {
            filteredNews = filteredNews.filter((entry: NewsListItem) => {
                return entry.category.some((c: string) => this.selectedCategories.includes(c));
            });
        }
        //This always returns [] - not good
        if (this.selectedProductAreas.length) {
            filteredNews = filteredNews.filter((entry: NewsListItem) => {
                return entry.productArea.some((c: string) => this.selectedProductAreas.includes(c));
            });
        }
        return filteredNews.filter((entry: NewsListItem) => {
            const title = entry.title.toLowerCase();
            return title.includes(this.searchQuery.toLowerCase());
        });
    }

    get productAreas() {
        const productAreas = new Set<string>();
        this.allNews.forEach((entry: NewsListItem) => {
            entry.productArea.forEach((area: string) => {
                productAreas.add(area);
            });
        });
        const areas = Array.from(productAreas);
        return areas.map((a: string) => {
            return {
                text: this.productAreaTranslation(a),
                value: a
            };
        });
    }
    get categories() {
        const categories = new Set<string>();
        this.allNews.forEach((entry: NewsListItem) => {
            entry.category.forEach((category: string) => {
                categories.add(category);
            });
        });
        const cats = Array.from(categories);
        return cats.map((cat: string) => {
            return {
                text: this.categoryTranslation(cat),
                value: cat
            };
        });
    }
}
